module.exports = __webpack_public_path__ + "static/media/routing-number.790d90a4.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/images/routing-number.PNG
// module id = 735
// module chunks = 0